/** CoStar.Api.AptsSearch.Criteria.GeographyMatchType */
export var GeographyMatchType;
(function (GeographyMatchType) {
    GeographyMatchType[GeographyMatchType["PostalCode"] = 2] = "PostalCode";
    GeographyMatchType[GeographyMatchType["City"] = 3] = "City";
    GeographyMatchType[GeographyMatchType["Submarket"] = 5] = "Submarket";
    GeographyMatchType[GeographyMatchType["County"] = 10] = "County";
    GeographyMatchType[GeographyMatchType["Subdivision"] = 11] = "Subdivision";
    GeographyMatchType[GeographyMatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyMatchType[GeographyMatchType["Cluster"] = 21] = "Cluster";
})(GeographyMatchType || (GeographyMatchType = {}));
import { GeographyFilterType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.Criteria.GeographyFilterType */
export { GeographyFilterType };
